import { render } from "./CountingGame.vue?vue&type=template&id=2207f0e1&scoped=true"
import script from "./CountingGame.vue?vue&type=script&lang=js"
export * from "./CountingGame.vue?vue&type=script&lang=js"

import "./CountingGame.vue?vue&type=style&index=0&id=2207f0e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2207f0e1"]])

export default __exports__